<script lang="ts">
  let {
    checked = $bindable(false),
    label,
    disabled = false,
    invalid = false,
    onchange,
    class: className = ''
  }: {
    checked?: boolean;
    label?: string;
    disabled?: boolean;
    invalid?: boolean;
    onchange?: (checked: boolean) => void;
    class?: string;
  } = $props();

  function handleChange(e: Event) {
    onchange?.((e.currentTarget as HTMLInputElement).checked);
  }
</script>

<label class="cb {className}" data-disabled={disabled || undefined} data-invalid={invalid || undefined}>
  <input
    type="checkbox"
    bind:checked
    {disabled}
    aria-invalid={invalid}
    onchange={handleChange}
  />
  <span class="box" aria-hidden="true"></span>
  {#if label}<span class="text">{label}</span>{/if}
</label>

<style>
  .cb {
    display: inline-flex;
    align-items: center;
    gap: var(--space-2);
    min-height: 44px;
    padding: 0 var(--space-1);
    cursor: pointer;
    font-size: var(--text-body);
    color: var(--color-text-primary);
    user-select: none;
  }

  .cb[data-disabled] {
    opacity: 0.5;
    cursor: not-allowed;
  }

  input {
    position: absolute;
    opacity: 0;
    pointer-events: none;
    width: 0;
    height: 0;
  }

  .box {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    flex: 0 0 auto;
    background: var(--color-surface);
    border: var(--border-width) solid var(--color-border-strong);
    border-radius: var(--radius-sm);
    transition:
      background var(--dur-fast) var(--ease-out),
      border-color var(--dur-fast) var(--ease-out),
      transform var(--dur-instant) var(--ease-out);
  }

  .box::after {
    content: '';
    width: 5px;
    height: 10px;
    border-left: 2px solid var(--color-accent-fg);
    border-bottom: 2px solid var(--color-accent-fg);
    transform: rotate(-45deg) translateY(-1px);
    opacity: 0;
    transition: opacity var(--dur-fast) var(--ease-out);
  }

  input:active + .box {
    transform: scale(0.92);
  }

  input:checked + .box {
    background: var(--color-accent);
    border-color: var(--color-accent);
  }

  input:checked + .box::after {
    opacity: 1;
  }

  input:focus-visible + .box {
    outline: var(--focus-ring-width) solid var(--color-focus-ring);
    outline-offset: 2px;
  }

  .cb[data-invalid] .box {
    border-color: var(--color-danger);
  }

  .cb:hover:not([data-disabled]) .box {
    border-color: var(--color-accent);
  }
</style>